import { createSelector } from '@reduxjs/toolkit';

import { TopicsGlobalScoreData } from '@/domain/impact-calculate/entities/calculate.entity';
import { selectImpactCalculateFestivalForProject } from '@/domain/impact-calculate-festival/impact-calculate-festival.selectors';
import { selectImpactCalculateTourForProject } from '@/domain/impact-calculate-tour/impact-calculate-tour.selectors';
import { selectImpactCalculateVenueForProject } from '@/domain/impact-calculate-venue/impact-calculate-venue.selectors';
import { selectCurrentProjectMode } from '@/domain/project/project.selectors';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { RootState } from '@/domain/store';

import { prepareTopicsGlobalScoreDataFestival } from './utils/prepare-topics-global-score-data-festival';
import { prepareTopicsGlobalScoreDataTour } from './utils/prepare-topics-global-score-data-tour';
import { prepareTopicsGlobalScoreDataVenue } from './utils/prepare-topics-global-score-data-venue';

export const selectTopicsGlobaScoreDataForProject = (projectId: number) =>
  createSelector(
    [
      selectCurrentProjectMode,
      (state: RootState) =>
        selectImpactCalculateFestivalForProject(projectId)(state),
      (state: RootState) =>
        selectImpactCalculateVenueForProject(projectId)(state),
      (state: RootState) =>
        selectImpactCalculateTourForProject(projectId)(state),
    ],
    (projectMode, calculateFestival, calculateVenue, calculateTour) => {
      let result: TopicsGlobalScoreData;
      switch (projectMode) {
        case 'festival':
          result = prepareTopicsGlobalScoreDataFestival(calculateFestival);
          break;
        case 'venue':
          result = prepareTopicsGlobalScoreDataVenue(calculateVenue);
          break;
        case 'tour':
          result = prepareTopicsGlobalScoreDataTour(calculateTour);
          break;
        default:
          throw new Error('No result for that project mode');
      }
      return result;
    },
  );

export const selectIncludePublicAnswersForCo2 = (state: RootState) => {
  const projectMode = selectCurrentProjectMode(state);
  if (projectMode !== 'festival') {
    throw new Error('No result for that project mode');
  }
  const project = selectCurrentProjectFestival(state);
  if (!project) {
    throw new Error('No project found');
  }
  return project.calculateOptions.includePublicAnswersForCo2;
};
